module.exports = __webpack_public_path__ + "static/media/live_court_right.d365a958.jpg";